const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__layer-1">
        <div className="footer__layer-1__content-1">
          <img src="/logo.png" alt="icon" />
          <h4>Hubungi Kami</h4>
          <ul>
            <li>ChiFlo Help You Anytime</li>
            <li>
              JL. Bebek Raya Nomor 34 Persil Nomor 4 Jakarta Selatan 12820, DKI
              Jakarta, Indonesia Telpon : 021-2138-3317
            </li>
            <li className="footer__layer-1__content-1__icons">
              <ul>
                <li>
                  <img src="/instagram-icon.png" alt="icon" />
                </li>
                <li>
                  <img src="/linkedin-icon.png" alt="icon" />
                </li>
                <li>
                  <img src="/youtube-icon.png" alt="icon" />
                </li>
              </ul>
            </li>
            <ul>
                <li>Tentang ChiFlo</li>
                <li>Tentang Kami</li>
                <li>Kontak Kami</li>
                <li>Karir</li>
                <li>Blog</li>
                <li>FAQ</li>
            </ul>
          </ul>
        </div>
        <div className="footer__layer-1__content-2">
          <h4>Perhatian</h4>
          <ol>
            <li>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Necessitatibus recusandae et quae repudiandae iure enim fugit.
              Repellendus accusamus voluptatibus obcaecati fugiat quasi,
              voluptas id aliquid voluptatum, hic amet, qui exercitationem.
            </li>
            <li>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Necessitatibus recusandae et quae repudiandae iure enim fugit.
              Repellendus accusamus voluptatibus obcaecati fugiat quasi,
              voluptas id aliquid voluptatum, hic amet, qui exercitationem.
            </li>
            <li>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Necessitatibus recusandae et quae repudiandae iure enim fugit.
              Repellendus accusamus voluptatibus obcaecati fugiat quasi,
              voluptas id aliquid voluptatum, hic amet, qui exercitationem.
            </li>
          </ol>
        </div>
        <div className="footer__layer-1__content-3">
          <h4></h4>
          <ol>
            <li>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Necessitatibus recusandae et quae repudiandae iure enim fugit.
              Repellendus accusamus voluptatibus obcaecati fugiat quasi,
              voluptas id aliquid voluptatum, hic amet, qui exercitationem.
            </li>
            <li>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Necessitatibus recusandae et quae repudiandae iure enim fugit.
              Repellendus accusamus voluptatibus obcaecati fugiat quasi,
              voluptas id aliquid voluptatum, hic amet, qui exercitationem.
            </li>
            <li>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Necessitatibus recusandae et quae repudiandae iure enim fugit.
              Repellendus accusamus voluptatibus obcaecati fugiat quasi,
              voluptas id aliquid voluptatum, hic amet, qui exercitationem.
            </li>
            
          </ol>
        </div>
      </div>
      <div className="footer__layer-2">
        <ul>
            <li>© 2022 PT Chiflo Membangun Bangsa. All rights reserved</li>
            <li>Syarat & Ketentuan</li>
            <li>Kebijakan Privasi</li>
        </ul>
      </div>
    </div>
  )
}

export default Footer
